import type { FaireProductEntity } from "../../entity_types/product";

export const p_7xy9dgwz2j: FaireProductEntity = {
  token: "p_7xy9dgwz2j",
  type: "product",
  name: "Knit Swaddle Blanket Nautical Ocean Baby Shower Gift Layette",
  brandToken: "b_f8d2cdf2",
  brandName: "The Blueberry Hill",
  imageUrl:
    "https://cdn.faire.com/fastly/9c8d5bec7a142aa11936d2196fe451628139596b1707c1fd31cd67b5ef817a95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df8ff2038a2900c1c14c389907af14b86896920ce3e3045a148cb04a86f505d0.jpeg",
    "https://cdn.faire.com/fastly/7db3de87f303e4fdce7a115e873122e1b2f06c0e8e685d5cd9f4bc55831adb2d.jpeg",
    "https://cdn.faire.com/fastly/8cb8fffcdf907d04acc788f93a22bcf295ccc575081b55d186936831d7dbfded.jpeg",
    "https://cdn.faire.com/fastly/44d62ea710b009060a1dd80b1fa308a375b516fdb367046855062dccdd8a54c8.jpeg",
    "https://cdn.faire.com/fastly/afdfb6446de53b16b0b81e53f2c1f67b5ea408b0a4e9caa6769e45726d071260.jpeg",
    "https://cdn.faire.com/fastly/20f46aecf6599b488523113381fe1b1e6998ea3124104b9e404104889711c62b.png",
  ],
  priceDollars: 21,
  description:
    "Wrap little ones up in our Layette swaddle blanket. Featuring our Nautical pattern with whales, crabs, waves, and more.\n\n- Designed in Salt Lake City\n- 100% GOTS Organic Cotton\n- Double-layered for extra softness and comfort\n- Breathable and gentle on delicate skin\n- Versatile for swaddling, cuddling, and on-the-go use\n\nCare instructions: Machine wash cool. Do not bleach. Tumble dry. Warm iron if required.\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:40.632Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
